hrd.AbstractDialogTooltip = hrd.Class.extend({
	$tooltip: undefined,
	$tooltipButton: undefined,
	formInstance: undefined,
	forceKeepOpen: false,

	init: function(tooltipName, options) {
		const defaults = {
			impl: 'hrd.AbstractDialogTooltip',
			onInitCompleted: () => { }
		};

		this._super($.extend({}, defaults, options));

		this.$tooltipButton = $(`[data-dialog-tooltip="${tooltipName}"]`);

		if (this.$tooltipButton.exists()) {
			if (!this.isEnabled()) {
				this.$tooltipButton.hide();

				return;
			}

			let content = this.htmlContent();

			if (!content) {
				content = '';
			}

			const usingChromaFlow = $('body.chroma-flow').exists();
			const chromaFlowClasses = usingChromaFlow ? 'popover closed' : '';
			const chromaFlowAttributes = usingChromaFlow ? `data-state="closed" data-side="${this.chromaSide || 'bottom'}" ${this.chromaAlign ? `data-align="${this.chromaAlign}"` : ''}` : '';

			const $tooltipWrapper = $('<div class="dialog-tooltip-wrapper"></div>');
			this.$tooltip = $(`
				<div id="${tooltipName}-tooltip" class="dialog-tooltip ${chromaFlowClasses}" ${chromaFlowAttributes}>
					<form id="${tooltipName}-tooltip-form">
						<fieldset>
							${typeof content === 'string' ? (content || '') : content.clone().show().html()}
						</fieldset>
					</form>
				</div>
			`);

			this.$tooltipButton.after($tooltipWrapper);
			$tooltipWrapper.append(this.$tooltipButton.detach());
			$tooltipWrapper.append(this.$tooltip);

			const TOOLTIP_ID = `#${tooltipName}-tooltip-form`;
			this.formInstance = new hrd.Form(TOOLTIP_ID, { reference: this });
			const formFactory = new hrd.HtmlFormFactory(TOOLTIP_ID);

			this.createHTMLFactory(formFactory);

			this.formInstance.enhanceAgain();
			this.formInstance.toForm(this.getDefaultFormData());

			$(document)
				.off(`.close-${tooltipName}`)
				.on(`click.close-${tooltipName}`, (event) => {
					if (!this.$tooltip.exists() || this.$tooltipButton.get(0).contains(event.target) || this.$tooltip.get(0).contains(event.target)) return;

					if (this.$tooltip.hasClass('open')) {
						if (!this.forceKeepOpen) {
							this.close()
								.then(() => this.onClose());
						}
					}
				});

			this.$tooltipButton
				.off(`.${tooltipName}`)
				.on(`click.${tooltipName}`, () => {
					if (this.$tooltip.hasClass('open')) {
						if (!this.forceKeepOpen) {
							this.close()
								.then(() => this.onClose());
							this.onClose();
						}
					} else {
						this.open();
						this.onOpen();
					}
				});

			this.doDirections();
			this.settings.onInitCompleted(this.$tooltip, this.$tooltipButton);
		}
	},
	htmlContent: $.noop,
	createHTMLFactory: $.noop,
	doDirections: function() {
		const directions = this.settings.directions || 'bottom left';
		const allowOverflow = this.settings.directions
			? true
			: !!this.settings.allowOverflow;

		this.$tooltip.addClass(directions);

		if (!allowOverflow) {
			const bounding = this.$tooltip.get(0).getBoundingClientRect();

			if (bounding.top < 0) {
				// Top is out of viewport
				this.$tooltip.removeClass('top');
				this.$tooltip.addClass('bottom');
			}

			if (bounding.left < 0) {
				// Left side is out of viewport
				this.$tooltip.removeClass('left');
				this.$tooltip.addClass('right');
			}

			if (bounding.bottom > $(window).height()) {
				// Bottom is out of viewport
				this.$tooltip.removeClass('bottom');
				this.$tooltip.addClass('top');
			}

			if (bounding.right > $(window).width()) {
				// Right side is out of viewport
				this.$tooltip.removeClass('right');
				this.$tooltip.addClass('left');
			}
		}
	},
	isEnabled: function() {
		return true;
	},
	getDefaultFormData: function() {
		return {};
	},
	onOpen: $.noop,
	onClose: $.noop,
	open: function() {
		const usingChromaFlow = $('body.chroma-flow').exists();

		this.$tooltip.addClass('open');

		if(usingChromaFlow) {
			this.$tooltip
				.removeClass('closed')
				.attr('data-state', 'open');
		}
	},
	close: function() {
		const deferred = $.Deferred();
		const usingChromaFlow = $('body.chroma-flow').exists();

		this.$tooltip.removeClass('open');

		if(usingChromaFlow) {
			this.$tooltip
				.attr('data-state', 'closed')
				.off('.popover-close')
				.one('animationend.popover-close', (event) => {
					deferred.resolve();
					if($(event.currentTarget).attr('data-state') !== 'closed') return;
					$(event.currentTarget).addClass('closed');
				});
		} else {
			deferred.resolve();
		}

		return deferred.promise();
	}
});